<script>

    import { toast } from 'bulma-toast'
    import { shopifyStore, shopifysStore, modalStore } from '../stores'

    import ShopifyService from '../$services/shopify.service'

    import Form from '../$components/form.svelte'
    import Select from '../$components/select.svelte'
    import InputText from '../$components/input.text.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import Delete from '../$components/delete.svelte'

    let loading = false
    let data = {
        status: $shopifyStore.status,
        domain: $shopifyStore.domain,
        apiKey: $shopifyStore.apiKey,
        secretKey: $shopifyStore.secretKey,
        link: $shopifyStore.link,
    }

    async function updateShopifyApp() {
    
        loading = true
        const resp = await ShopifyService.updateShopifyApp($shopifyStore._id, data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        shopifysStore.replace(resp.data)
        shopifyStore.set(resp.data)

        toast({message: 'Solicitud actualizada', type: 'is-success'})
        modalStore.close()
    }

    async function deleteShopifyApp() {

        loading = true
        const resp = await ShopifyService.deleteShopifyApp($shopifyStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        shopifysStore.remove($shopifyStore._id)

        modalStore.close()
    }

</script>

<Form on:submit={updateShopifyApp} { loading } >

    <Select bind:value={ data.status } 
        label="Estatus"
        options={[
            {value: 'pending', text: 'pending'},
            {value: 'success', text: 'success'}
        ]}
    />

    <InputText bind:value={data.domain} label="Dominio" placeholder="dominio" />
    <InputText bind:value={data.apiKey} label="Api key" placeholder="Api key" />
    <InputText bind:value={data.secretKey} label="Secret key" placeholder="Secret key" />
    <InputText bind:value={data.link} label="Link" placeholder="Link" />

    <div class="items-end">
        <div class="buttons">
            <Delete on:confirm={ deleteShopifyApp } text="Borrar" />
            <ButtonSave icon="edit" text="Actualizar" { loading } />
        </div>
    </div>
</Form>